/* eslint-disable consistent-return */
/* eslint-disable react/jsx-curly-brace-presence */
/* eslint-disable prefer-const */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable object-shorthand */
import React, { useState } from 'react';
import { Col, Form, Row, Spinner } from 'react-bootstrap';
import MaskedInput from 'react-text-mask';
import { toast } from 'react-toastify';
import { customerInputsLength } from '../../../../constants/customerInputsLength';
import UserHttpService from '../../../../services/http/user-http';
import { cnpjMask, cpfMask, phoneMask } from '../../../../utils/masks';
import { normalizeCityName } from '../../../../utils/strings';
import { StyledFormControl } from './styles';
import BrasilService from '../../../../services/http/brasil.http';

const CustomerUser = (props: any) => {
    const [loadingSintegraData, setLoadingSintegraData] = useState(false);

    const getCitiesByState = async (state: string) => {
        const response = await BrasilService.getCitiesByState(state);

        // eslint-disable-next-line arrow-body-style
        const cities = response.map((obj) => {
            return {
                label: obj.name,
                value: obj.id,
            };
        });

        return cities;
    };

    const handleCnpjChanges = async (event: any) => {
        const value: any = event?.target?.value?.replace(/\D/g, '');

        props.handleChanges([{ target: { name: 'document', value } }]);

        const changes: any = [];
        if (value.length === 14) {
            setLoadingSintegraData(true);

            try {
                let { data } = await UserHttpService.cnpjConsultation(value);

                if (!data) {
                    return toast.info(
                        'Não foi possível consultar o CNPJ. Prossiga com o cadastro manualmente.',
                    );
                }

                const cities = await getCitiesByState(data?.state);

                const city: any = cities.find(
                    (item: any) =>
                        normalizeCityName(item.label) ===
                        normalizeCityName(data?.city),
                );

                changes.push({ target: { name: 'document', value } });
                changes.push({
                    target: {
                        name: 'fancyName',
                        value: data?.fancyName?.substring(
                            0,
                            customerInputsLength.fancyName,
                        ),
                    },
                });
                changes.push({
                    target: {
                        name: 'name',
                        value: data?.name?.substring(
                            0,
                            customerInputsLength.name,
                        ),
                    },
                });

                if (
                    data.stateRegistration !== "ISENTO"
                ) {
                    changes.push({ target: { name: 'hasIe', value: true } });
                    changes.push({
                        target: {
                            name: 'ie',
                            value: data?.stateRegistration,
                        },
                    });
                } else {
                    changes.push({ target: { name: 'hasIe', value: false } });
                    changes.push({ target: { name: 'ie', value: '' } });
                }

                changes.push({
                    target: {
                        name: 'erpState',
                        value: { label: data?.state, value: data?.state },
                    },
                });
                changes.push({
                    target: {
                        name: 'erpCity',
                        value: city.value || data?.erpCity,
                    },
                });
                changes.push({
                    target: {
                        name: 'erpCityName',
                        value: city.label || data?.city,
                    },
                });
                changes.push({
                    target: {
                        name: 'addressCep',
                        value: data?.cep,
                    },
                });
                changes.push({
                    target: {
                        name: 'addressDescription',
                        value: data?.addressDescription?.substring(
                            0,
                            customerInputsLength.addressDescription,
                        ),
                    },
                });
                changes.push({
                    target: {
                        name: 'addressNeighborhood',
                        value: data?.addressNeighborhood?.substring(
                            0,
                            customerInputsLength.addressNeighborhood,
                        ),
                    },
                });
                changes.push({
                    target: {
                        name: 'addressNumber',
                        value: data?.addressNumber?.substring(
                            0,
                            customerInputsLength.addressNumber,
                        ),
                    },
                });
                changes.push({
                    target: {
                        name: 'addressComplement',
                        value: data?.addressComplement?.substring(
                            0,
                            customerInputsLength.addressComplement,
                        ),
                    },
                });

                props.handleChanges(changes);
            } catch (err) {
                let error = err as any;

                toast.error(error.message || 'Erro ao buscar CNPJ');
            } finally {
                setLoadingSintegraData(false);
            }
        }
    };

    return (
        <>
            <Row>
                {props.documentType === 'J' ? (
                    <>
                        <Col lg={12} md={12}>
                            {loadingSintegraData && !props.errors.document && (
                                <>
                                    <p>
                                        <Spinner
                                            animation={'border'}
                                            size="sm"
                                            className="mr-2"
                                        />
                                        Buscando informações da empresa...
                                    </p>
                                </>
                            )}
                        </Col>
                        <Col lg={12} md={12}>
                            <Form.Group controlId="formBasicName">
                                <Form.Label>Nome Fantasia</Form.Label>
                                <Form.Control
                                    disabled={props.customer.id}
                                    value={props.customer.fancyName}
                                    onChange={props.handleChanges}
                                    name="fancyName"
                                    maxLength={customerInputsLength.fancyName}
                                    type="text"
                                />
                            </Form.Group>
                        </Col>
                        <Col lg={6} md={6}>
                            <Form.Group controlId="formBasicCnpj">
                                <Form.Label>CNPJ</Form.Label>
                                <Form.Control
                                    disabled={props.customer.id}
                                    value={props.customer.document}
                                    isInvalid={!!props.errors.document}
                                    as={MaskedInput}
                                    mask={cnpjMask}
                                    onChange={handleCnpjChanges}
                                    name="document"
                                    type="text"
                                />
                                {props.errors.document && (
                                    <Form.Control.Feedback type="invalid">
                                        {props.errors.document}
                                    </Form.Control.Feedback>
                                )}
                            </Form.Group>
                        </Col>
                    </>
                ) : (
                    <>
                        <Col lg={6} md={6}>
                            <Form.Group controlId="formBasicName">
                                <Form.Label>CPF</Form.Label>
                                <Form.Control
                                    disabled={props.customer.id}
                                    value={props.customer.document}
                                    isInvalid={!!props.errors.document}
                                    as={MaskedInput}
                                    mask={cpfMask}
                                    onChange={props.handleChanges}
                                    name="document"
                                    type="text"
                                />
                                <Form.Control.Feedback type="invalid">
                                    {props.errors.document}
                                </Form.Control.Feedback>
                            </Form.Group>
                        </Col>
                    </>
                )}

                <Col lg={6} md={12}>
                    <Form.Group controlId="formBasicIe">
                        <Form.Label>Possui Inscrição Estadual?</Form.Label>
                        <Form.Check
                            id="switchIe"
                            name="hasIe"
                            type="switch"
                            className="float-left"
                            checked={!props.hasIe}
                            onChange={() => {
                                props.setHasIe(!props.hasIe);

                                // eslint-disable-next-line no-param-reassign
                                if (props.hasIe) {
                                    // eslint-disable-next-line no-param-reassign
                                    props.customer.ie = "";
                                } else {
                                    // eslint-disable-next-line no-param-reassign
                                    props.customer.ie = "ISENTO";
                                }
                            }}
                        />
                        <StyledFormControl
                            disabled={
                                props.isDisabled ||
                                props.hasIe
                            }
                            value={!props.hasIe ? props.customer.ie : "ISENTO"}
                            isInvalid={!!props.errors.ie}
                            onChange={props.handleChanges}
                            name="ie"
                            type="text"
                            placeholder={
                                !props.hasIe
                                    ? 'Digite a Inscrição Estadual...'
                                    : 'Isento'
                            }
                        />
                        {props.errors.ie && (
                            <Form.Control.Feedback type="invalid">
                                {props.errors.ie}
                            </Form.Control.Feedback>
                        )}
                    </Form.Group>
                </Col>

                <Col lg={12} md={12}>
                    <Form.Group controlId="formBasicName">
                        <Form.Label>Nome</Form.Label>
                        <Form.Control
                            disabled={props.customer.id}
                            isInvalid={!!props.errors.name}
                            onChange={props.handleChanges}
                            value={props.customer.name}
                            name="name"
                            type="text"
                            maxLength={customerInputsLength.name}
                        />

                        <Form.Control.Feedback type="invalid">
                            {props.errors.name}
                        </Form.Control.Feedback>
                    </Form.Group>
                </Col>

                <Col lg={6} md={12}>
                    <Form.Group controlId="formBasicPhone">
                        <Form.Label>Telefone</Form.Label>
                        <Form.Control
                            value={props.customer.phone}
                            isInvalid={!!props.errors.phone}
                            as={MaskedInput}
                            mask={phoneMask}
                            onChange={props.handleChanges}
                            name="phone"
                            type="tel"
                        />

                        <Form.Control.Feedback type="invalid">
                            {props.errors.phone}
                        </Form.Control.Feedback>
                    </Form.Group>
                </Col>
                <Col lg={6} md={12}>
                    <Form.Group controlId="formBasicEmail">
                        <Form.Label>
                            E-mail (utilize exclusivamente o e-mail do cliente)
                        </Form.Label>
                        <Form.Control
                            isInvalid={!!props.errors.email}
                            onChange={props.handleChanges}
                            value={props.customer.email}
                            name="email"
                            maxLength={100}
                            type="email"
                        />

                        <Form.Control.Feedback type="invalid">
                            {props.errors.email}
                        </Form.Control.Feedback>
                    </Form.Group>
                </Col>
            </Row>
        </>
    );
};

export default CustomerUser;
